export const API_URL = process.env.GRN_API_URL;

export const API_TYPE = (action: string) => ({
  STARTED: `${action}_STARTED`,
  FULLFILLED: `${action}_FULLFILLED`,
  REJECTED: `${action}_REJECTED`,
  RESET: `${action}_RESET`,
});
